import { render, staticRenderFns } from "./LikertType.vue?vue&type=template&id=b8a9248a&scoped=true&"
import script from "./LikertType.vue?vue&type=script&lang=js&"
export * from "./LikertType.vue?vue&type=script&lang=js&"
import style0 from "./LikertType.vue?vue&type=style&index=0&id=b8a9248a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a9248a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VInput } from 'vuetify/lib/components/VInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VInput,VRadio,VRadioGroup,VRow,VSimpleTable})
